import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 md:mt-8 md:mx-auto container"
}
const _hoisted_2 = { class: "w-full shadow rounded mb-8" }
const _hoisted_3 = { class: "bg-gray-700 flex-col md:flex-row flex rounded-t" }
const _hoisted_4 = { class: "flex p-4 md:w-4/5" }
const _hoisted_5 = {
  key: 1,
  class: "text-2xl text-white break-all text-center"
}
const _hoisted_6 = { class: "bg-black text-white p-2 pl-4 flex justify-between" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "bg-white p-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3"
}
const _hoisted_10 = { class: "h-32 rounded-md shadow bg-gray-700 text-white p-3 flex items-center justify-center transform hover:scale-105" }
const _hoisted_11 = ["src", "alt", "title"]
const _hoisted_12 = {
  key: 1,
  class: "text-2xl break-words text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_image = _resolveComponent("b-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    loading: _ctx.$apollo.loading
  }, {
    default: _withCtx(() => [
      (_ctx.network)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.network.logo)
                    ? (_openBlock(), _createBlock(_component_b_image, {
                        key: 0,
                        src: _ctx.network.logo.url,
                        class: "max-h-24 object-contain"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.network.name), 1))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.network.name), 1),
                _hoisted_8
              ]),
              (_ctx.sites)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites.collection, (site) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: site.id,
                        to: `/sites/${site.short_name}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            (site.logo)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: site.logo.url,
                                  alt: site.name,
                                  title: site.name,
                                  class: "max-h-24 object-contain"
                                }, null, 8, _hoisted_11))
                              : (_openBlock(), _createElementBlock("h1", _hoisted_12, _toDisplayString(site.name), 1))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}